<h1 mat-dialog-title>
  Tell us about your experience with hired contractor: {{ name }}
</h1>
<div mat-dialog-content>
  <form
    [formGroup]="formContractorReview"
    autocomplete="nope"
    style="width: 100%;"
  >
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Review</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        required
        [readonly]="Reviewreadonly()"
        placeholder=""
        id="review"
        name="review"
        formControlName="review"
        maxlength="2000"
        (change)="ebbContractorReviewInputChange($event)"
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="10"
      ></textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="showContractorResponse"  style="width: 100%;">
      <mat-label>Response</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        readonly="true"
        placeholder=""
        id="response"
        name="response"
        formControlName="response"
        maxlength="2000"
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="10"
      ></textarea>
    </mat-form-field>
  </form>
</div>
<div
  mat-dialog-actions
  style="margin-top: 9px !important; float: right !important;"
>
  <button mat-button (click)="onClickCancel()">CANCEL</button>
  <button
    mat-flat-button
    (click)="onSave()"
    [mat-dialog-close]="data"
    color="primary"
    [disabled]="DisableSave()"
  >
    SAVE
  </button>
</div>
